<template>
  <div class="relative">
    <el-input
        :type="inputType"
        :value="value"
        @input="onInput"
        @change="onChange"
        @focus="onFocus"
        @blur="onBlur"
        ref="reference"
        @copy.native="onCopy"
        @paste.native="onPaste"
        @cut.native="onCut"
        :placeholder="placeholderValue"
        v-bind="$attrs"
        clearable
        :autocomplete="autocomplete"
    >
      <template v-slot:append>
        <slot name="append"></slot>
      </template>
    </el-input>
    <el-select-dropdown ref="popper" v-if="enableRelation && visible && selectList.length">
      <ul>
        <li v-for="item in selectList" :key="item" class="py-2 px-3 cursor-pointer hover:bg-theme-gray text-medium">
          <div @click="onSelect(item)">
            <span>{{ item }}</span>
          </div>
        </li>
      </ul>
    </el-select-dropdown>
    <div v-if="showErrorTip" class="mt-2 p-2 danger-box">
      {{ errorTip }}
    </div>
  </div>
</template>

<script>
import ElSelectDropdown from 'dygc-ui/packages/select/src/select-dropdown'
import { getHistoryQuestionAnswer, getTextFillErrorTip } from 'dygc'
import disableCopyMixin from '../text-fill/disableCopyMixin'

export default {
  name: 'RelationInput',
  components: { ElSelectDropdown },
  mixins: [disableCopyMixin],
  props: {
    value: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    questionId: {
      type: String,
      default: ''
    },
    optionId: {
      type: String,
      default: ''
    },
    questionType: {
      type: Number
    },
    enableRelation: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    disableCopy: {
      type: Boolean,
      default: false
    },
    minLength: {
      type: Number,
      default: -1
    },
    maxLength:{
      type: Number,
      default: -1
    },
    validate:{
      type: String,
      default: null
    },
    enabledErrorTip:{
      type: Boolean,
      default:true
    },
    allowErrorList:{
      type:Array,
      default:()=>[]
    }
  },
  data() {
    return {
      visible: false,
      selectList: []
    }
  },
  computed: {
    showErrorTip() {
      if(!this.enabledErrorTip) return false
      return !!this.errorTip.length
    },
    errorTip() {
      if(!this.value) return ''
      if(this.allowErrorList.includes(this.value.toString().trim())) return ''
      return getTextFillErrorTip(this.value,{maxLength:this.maxLength,minLength:this.minLength,validate:this.validate})
    },
    placeholderValue() {
      if (this.placeholder) return this.placeholder
      return '请输入'
    },
    inputType() {
      const type = this.type
      if (type === 'number') return 'text'
      return type
    },
    autocomplete() {
      if (this.inputType === 'password') {
        return 'new-password'
      } else {
        return 'off'
      }
    }
  },
  methods: {
    onSelect(item) {
      this.$emit('input', item)
      this.visible = false
    },
    onInput(event) {
      this.$emit('input', event)
    },
    onBlur() {
      setTimeout(() => {
        this.visible = false
      }, 200)
    },
    onChange(e) {
      this.$emit('change', e)
    },
    onFocus() {
      this.visible = true
      this.$nextTick(() => {
        if (this.$refs.popper) this.$refs.popper.$emit('updatePopper')
      })
    },
    searchHandler(val) {
      const tmp = (this.tmp = Math.random() * 100000)
      getHistoryQuestionAnswer({
        surveyId: this.$bus.survey.id,
        questionId: this.questionId,
        questionType: this.questionType,
        optionId: this.optionId,
        keyWord: val
      }).then(res => {
        if (tmp !== this.tmp) return
        this.selectList = res.data
        this.$nextTick(() => {
          this.$refs.popper.$emit('updatePopper')
        })
      })
    }
  },
  watch: {
    value(val) {
      if (!this.enableRelation) return
      if (!val.trim()) {
        this.selectList = []
        return
      }
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.searchHandler(val)
      }, 200)
    }
  }
}
</script>
